/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import CittaTelemetry from '../../common/telemetry/citta-telemetry';
import { subscribeEmailAction, SubscribeEmailDataActionInput } from '../../data-actions/subscribe-email/subscribe-email-data';
import { ICittaUserSubscribedData } from './citta-user-subscribed.data';
import { ICittaUserSubscribedProps } from './citta-user-subscribed.props.autogenerated';

export interface ICittaUserSubscribedViewProps extends ICittaUserSubscribedProps<ICittaUserSubscribedData> {}

/**
 *
 * CittaUserSubscribed component
 * @extends {React.PureComponent<ICittaUserSubscribedProps<ICittaUserSubscribedData>>}
 */
class CittaUserSubscribed extends React.PureComponent<ICittaUserSubscribedProps<ICittaUserSubscribedData>> {
    private cittaTelemetry: CittaTelemetry;

    constructor(props: ICittaUserSubscribedProps<ICittaUserSubscribedData>) {
        super(props);
        this.cittaTelemetry = new CittaTelemetry(this.props.context.app.config.cittaInstrumentationKey);
    }

    public async componentDidMount(): Promise<void> {
        const url = decodeURI(window.location.search);
        const urlParams = new URLSearchParams(url);
        urlParams.delete('token'); // laybuy
        urlParams.delete('orderToken'); // afterpay
        urlParams.delete('sessionid'); // payment express

        this._logMessage(`Citta user subscribed loaded ${urlParams.toString()}`);

        /* tslint:disable:no-string-literal */
        const isNewUser = (this.props.context.request && this.props.context.request.user && this.props.context.request.user['userClaims'] &&
        this.props.context.request.user['userClaims'][this.props.config.newUserKey || 'IsNewUser'] &&
        this.props.context.request.user['userClaims'][this.props.config.newUserKey || 'IsNewUser'] === 'true') ? true : false;
        const isSubscribedToNewsletter = (this.props.context.request && this.props.context.request.user && this.props.context.request.user['userClaims'] &&
        this.props.context.request.user['userClaims'][this.props.config.subscriptionKey || 'SubscribeToNewsletter'] &&
        this.props.context.request.user['userClaims'][this.props.config.subscriptionKey || 'SubscribeToNewsletter'] === 'true') ? true : false;
        const userEmail = this.props.context.request.user && this.props.context.request.user.emailAddress || '';

        if (isNewUser && isSubscribedToNewsletter) {
            try {
                await subscribeEmailAction(new SubscribeEmailDataActionInput(userEmail, isSubscribedToNewsletter), this.props.context.actionContext);
            } catch(e) {
                this.props.telemetry.error(`Something went wrong ------${e}`);
            }
        }
    }

    public render(): JSX.Element | null {
        const moduleprops = {
            ...this.props
        };
        return this.props.renderView(moduleprops) as React.ReactElement;
    }

    private _logMessage(message: string): void {
        const {
            Id,
            TotalItems
        } = this.props.data.activeCart.result!;

        this.cittaTelemetry.trace(`CartId:${Id} TotalItem:${TotalItems} - ${message}`);
    }
}

export default CittaUserSubscribed;
